import { Card, CardBody, CardHeader, Table } from "reactstrap"
import { BANKS } from "../../utils/bankConstants";

const ACCOUNT_TYPES = [
  { id: 1, label: "Cuenta Corriente" },
  { id: 2, label: "Cuenta de Ahorros" },
  { id: 3, label: "Efectivo", disabled: true },
  { id: 4, label: "Número de Celular" }
];



export const CardUserOrder = ({ order }) => {
    return (
        <Card className="shadow-sm mt-4">
            <CardHeader tag="h5">Datos del usuario</CardHeader>
            <CardBody>
                <Table borderless responsive>
                    <tbody>
                        <tr>
                            <th>Codigo</th>
                            <td>{order.user_id.multyhealth_code}</td>
                        </tr>
                        <tr>
                            <th>Documento</th>
                            <td>{order.user_id?.document}</td>
                        </tr>
                        <tr>
                            <th>Nombre</th>
                            <td>{order.user_id.name}</td>
                        </tr>
                        <tr>
                            <th>Teléfono</th>
                            <td>{order.user_id.cellphone}</td>
                        </tr>
                        <tr>
                            <th>Correo</th>
                            <td>{order.user_id.email}</td>
                        </tr>
                        <tr>
                            <th>Registrado en</th>
                            <td>{new Date(order.user_id.createdAt).toLocaleDateString()}</td>
                        </tr>
                        {order.user_id?.bankAccount?.accountType && order.user_id?.bankAccount?.bankCode && order.user_id?.bankAccount?.accountNumber ?(
                            <>
                                <tr>
                                    <th>Tipo de cuenta</th>
                                    <td>{ACCOUNT_TYPES.find(bank=>bank.id == order.user_id?.bankAccount.accountType)?.label }</td>
                                </tr>
                                <tr>
                                    <th>Cuenta bancaria</th>
                                    <td>{BANKS.find(bank=>bank.id == order.user_id?.bankAccount.bankCode).name }</td>
                                </tr>
                                <tr>
                                    <th>Número de cuenta</th>
                                    <td>{order.user_id?.bankAccount.accountNumber}</td>
                                </tr>
                            </>
                        ):<tr>
                            <th>Datos bancarios</th>
                            <td>No registrados</td>
                        </tr>}
                        
                    </tbody>
                </Table>
            </CardBody>
        </Card>
    )
}
